﻿'use strict'

import $ from 'jquery';
import * as Backbone from 'backbone';
import * as Marionette from 'backbone.marionette';
import * as _ from 'underscore';
import * as Bootstrap from 'bootstrap';

import tpl_pgEvents4usError from './tpl/pgEvents4usError.html';
import language from '../../../common/language';
import View_LayoutError from '../../../lib/views/layoutError/layoutError';

import * as Entities_Empty from '../../../lib/entities/empty';

export default View_LayoutError.extend({
    getTemplate: function () {
        return tpl_pgEvents4usError({ model: this.model.toJSON() });
    },
    initialize: function () {
        this.app = this.options.app;

        this.model.attributes.Header = resources[this.model.attributes.HeaderNumber];
        var title = resources[this.model.attributes.TitleNumber];
        this.model.attributes.Title = String.format(title, this.model.attributes.FirstName);
        this.model.attributes.Error = String.format(resources.X100727, this.model.attributes.Orderid, this.getActionCode(this.model.attributes.Actioncode));
    },
    getActionCode: function (actioncode) {
        var ret = "";
        switch(actioncode) {
            case '0' : ret = 'Successful action'; break; 
            case '1' : ret = 'Transaction declined'; break; 
            case '2' : ret = 'Possible fraud'; break; 
            case '3' : ret = 'Communication error'; break; 
            case '4' : ret = 'Card is expired'; break; 
            case '5' : ret = 'PBS internal system error'; break;  
            case '6' : ret = 'Invalid Transaction'; break; 
            case '7' : ret = 'System error'; break; 
            case '8' : ret = 'Wrong merchant number'; break; 
            case '9' : ret = 'No card record'; break; 
            case '10' : ret = 'Card entry below low range'; break; 
            case '11' : ret = 'Transaction not permitted to terminal'; break; 
            case '12' : ret = 'Transaction not permitted to cardholder'; break; 
            case '13' : ret = 'Invalid card number'; break; 
            case '14' : ret = 'Unauthorized content in cardnum field'; break; 
            case '15' : ret = 'Unauthorized content in expiry month'; break; 
            case '16' : ret = 'Unauthorized content in expiry year'; break; 
            case '17' : ret = 'Unauthorized content in CVC'; break; 
            case '18' : ret = 'Card number is not authorized according to cardtype.'; break; 
            case '19' : ret = 'Not a unique orderid'; break; 
            case '20' : ret = 'Empty amount'; break; 
            case '21' : ret = 'Not a valid md5checksum'; break; 
            case '22' : ret = 'Netbank authorize failed'; break; 
            case '23' : ret = 'Netbank authorize cancelled by customer.'; break; 
            case '24' : ret = 'Icash payment failed'; break; 
            case '25' : ret = 'MAC hash is invalid'; break; 
        }
        return ret;
    },
    onBeforeShow: function () {
    },
    ui: {
    },
    events: {
    },
    onRender: function () {
    },
    onAttach(){
    },
    onDestroy(){
    }
}, Backbone.Radio.Requests);
